import { useQuery } from '@tanstack/react-query';

import { getCurrencyCodeSelectOptionByIsoCode } from './currencyCodes';
import { TypesenseCollection } from '../types';
import { useGetTypeSenseAPIKeys } from '@/api/REST/typeSenseAPIKeys';

const CURRENCY_CODE_OPTION_KEY = 'currencyCodeOption';
export const useGetCurrencyCodeOptionByIsoCode = (
  isoCode: string | undefined,
) => {
  const { data: apiKeys } = useGetTypeSenseAPIKeys();
  const collectionApiKey =
    apiKeys?.[TypesenseCollection.CURRENCY_CODES.keyName]?.key ?? null;

  const { data, ...restProps } = useQuery({
    queryKey: [CURRENCY_CODE_OPTION_KEY, isoCode, collectionApiKey],
    queryFn: () =>
      getCurrencyCodeSelectOptionByIsoCode(isoCode!, collectionApiKey!),
    enabled: !!isoCode && !!collectionApiKey,
  });

  return { data, ...restProps };
};
